import styled from '@emotion/styled';
import { token } from '@ferreri/prever-component-lib';

export const CategoriesListWrapContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: ${token.spacing.spacingSmall};
  width: 100%;
`;
